import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '~/state/hooks'
import { useModalOpened, useModalToggle } from '~/state/application/hooks'
import { useSpotSwapUserConfig } from '~/state/dex/hooks'
import { updateSpotSwapUserConfig } from '~/state/dex/actions'
import { ApplicationModal } from '~/state/application/reducer'
import Modal from '~/components/Modal'
import ProgressiveImg from '~/components/ProgressiveImg'
import { LOCALES } from '~/locales'
import {
  Container,
  StyledTitle,
  Content,
  StyledButton,
  StyledButtonGroup,
} from './styled'
import PicGuideEN from '~/assets/images/toggle-settings-to-set-pay-mode-en.gif'
import PicGuideZH from '~/assets/images/toggle-settings-to-set-pay-mode-zh.gif'
import PlaceholderImg from '~/assets/images/toggle-settings-to-set-pay-mode-placeholder.png'

const MiniSetPayModeModal = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const { sendByRelayer } = useSpotSwapUserConfig()
  const toggle = useModalToggle(ApplicationModal.MINI_SET_PAY_MODE)
  const isOpen = useModalOpened(ApplicationModal.MINI_SET_PAY_MODE)

  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const PicGuide = isZh ? PicGuideZH : PicGuideEN

  const toggleSendOrderMode = () => {
    dispatch(updateSpotSwapUserConfig({ sendByRelayer: !sendByRelayer }))
  }

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={toggle}
      animate={false}
      contentClassName="mini-set-pay-mode"
    >
      <Container>
        <StyledTitle>{t('miniSetPayModeModal.title')}</StyledTitle>
        <Content>
          <ProgressiveImg
            src={PicGuide.src}
            placeholderSrc={PlaceholderImg.src}
            width={300}
            height={125}
            style={{ borderRadius: '10px' }}
            alt="guide"
          />
          <p>{t('miniSetPayModeModal.desc')}</p>
        </Content>
        <StyledButtonGroup>
          <StyledButton operateType="cancel" onClick={toggle}>
            {t('later')}
          </StyledButton>
          <StyledButton
            operateType="confirm"
            onClick={() => {
              !sendByRelayer && toggleSendOrderMode()
              toggle()
            }}
          >
            {t('enable')}
          </StyledButton>
        </StyledButtonGroup>
      </Container>
    </Modal>
  )
}

export default MiniSetPayModeModal
